/* 通用流程 */
const layoutComponent = () => import('@/views/layout')

export default [
  {
    path: '/generalProcessManagement',
    component: layoutComponent,
    meta: {
      title: 'menu.generalProcessManagement',
      icon: 'el-icon-ali-GenalProcessManagement'
    },
    children: [
      {
        path: '/generalProcessManagement/index',
        name: 'generalProcessManagement',
        component: () => import('@/views/generalProcessManagement/index.vue'),
        meta: {
          title: 'menu.generalProcessManagement',
          buttons: [
            { code: 'scan', name: '浏览' },
            { code: 'add', name: '新增' },
            { code: 'delete', name: '删除' },
            { code: 'edit', name: '编辑' },
            { code: 'view', name: '查看' },
            { code: 'push', name: '推送' },
            { code: 'copy', name: '复制' }
          ]
        }
      },
      {
        path: '/generalProcessManagement/generalProcessAdd',
        name: 'generalProcessAdd',
        component: () => import('@/views/generalProcessManagement/generalProcessAdd.vue'),
        meta: {
          title: 'menu.generalProcessAdd',
          routeNameParent: 'generalProcessManagement'
        }
      },
      {
        path: '/generalProcessManagement/generalProcessEdit',
        name: 'generalProcessEdit',
        component: () => import('@/views/generalProcessManagement/generalProcessEdit.vue'),
        meta: {
          title: 'menu.generalProcessEdit',
          routeNameParent: 'generalProcessManagement'
        }
      },
      {
        path: '/generalProcessManagement/generalProcessView',
        name: 'generalProcessView',
        component: () => import('@/views/generalProcessManagement/generalProcessView.vue'),
        meta: {
          title: 'menu.generalProcessView',
          routeNameParent: 'generalProcessManagement'
        }
      },
      {
        path: '/generalProcessManagement/generalProcessCopy',
        name: 'generalProcessCopy',
        component: () => import('@/views/generalProcessManagement/generalProcessCopy.vue'),
        meta: {
          title: 'menu.generalProcessCopy',
          routeNameParent: 'generalProcessManagement'
        }
      },
    ]
  }
]
